import { render } from "./Nav-component.vue?vue&type=template&id=0155aaee&scoped=true"
import script from "./Nav-component.vue?vue&type=script&lang=js"
export * from "./Nav-component.vue?vue&type=script&lang=js"

import "./Nav-component.vue?vue&type=style&index=0&id=0155aaee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0155aaee"]])

export default __exports__